import React, { useEffect, useState } from "react";
import ScrollButton from "../components/scroll_button";
import Layout from "../components/layout";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import xss from "xss";
import styles from "../styles/news.module.scss";
import ReactMarkdown from "react-markdown";

export default function News() {
  const router = useRouter();
  const { t } = useTranslation("common");

  const [news, setNews] = useState([]);
  // const [isLoad, setIsLoad] = useState(false);
  const [count, setCount] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [openNews, setOpenNews] = useState();
  const [error, setError] = useState(false);

  const dates = {
    ru: {
      "01": "Января",
      "02": "Февраля",
      "03": "Марта",
      "04": "Апреля",
      "05": "Мая",
      "06": "Июня",
      "07": "Июля",
      "08": "Августа",
      "09": "Сентября",
      10: "Октября",
      11: "Ноября",
      12: "Декабря",
    },
    en: {
      "01": "January",
      "02": "February",
      "03": "March",
      "04": "April",
      "05": "May",
      "06": "June",
      "07": "July",
      "08": "August",
      "09": "September",
      10: "October",
      11: "November",
      12: "December",
    },
  };

  useEffect(() => {
    fetch(`${process.env.API_URL}/articles_count`)
      .then((response) => {
        response
          .json()
          .then((data) => {
            setCount(Math.ceil(data / 3));
            setError(false);
          })
          .catch((_e) => {
            setError(true);
          });
      })
      .catch((_e) => {
        setError(true);
      });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(
      `${process.env.API_URL}/articles?limit=3&offset=${ (currentPage - 1) * 3 }`)
      .then((response) => {
        response
          .json()
          .then((data) => {
            setNews(data);
            // setIsLoad(true);
            setError(false);
          })
          .catch((_e) => {
            setError(true);
          });
      })
      .catch((_e) => {
        setError(true);
      });
  }, [currentPage]);

  const returnPaging = current => {
    const array = count <= 5 ? new Array(count).fill(1).map((_, index) => index + 1) : current === 1 ? [1, 2] : current === count ? [count - 1, count] : [current - 1, current, current + 1];
    return <>
      { current >= 3 ? <>
        <div className={current === 1 ? 'current' : ''} onClick={() => setCurrentPage(1)}>
          1
        </div>
        { current !== 3 ? <span>...</span> : <></> }
        </> : <></>
      }
      {array.map((value, index) => (
        <div key={index} className={current === value ? styles.current : ''} onClick={() => setCurrentPage(value)}>
            {value}
        </div>)
      )
      }
      { current <= count - 2 ? <>
        { current !== count - 2 ? <span>...</span> : <></> }
        <div className={current === count ? 'current' : ''} onClick={() => setCurrentPage(count)}>
          {count}
        </div></> : <></>
      }
    </>
  };

  const articles = news.length ? (
    news.map((news) => {
      const imgName = news.image_src?.split("/");
      return (
        <div key={news.id} className={styles.item}>
          <div className={styles.img_block}>
            <img src={imgName[1] === 'packs' ? `/news/${imgName[imgName.length - 1].split('-')[0]}.webp` : news.image_src.replace('.png', '.webp')} alt={imgName} />
          </div>
          <div className={styles.news_info}>
            <h2 className={styles.date}>{news.created_at.substr(8, 2)}</h2>
            <p className={styles.date}>
              {dates[router.locale][news.created_at.substr(5, 2)]}
            </p>

            <h3>{news[(router.locale === "ru" ? "" : "eng_") + "title"]}</h3>
            <div
              className={styles[openNews === news.id ? "open" : "description"]}
            >
              {
                imgName[1] !== 'packs' ? <ReactMarkdown>{router.locale === "ru" ? news.text: news.eng_text}</ReactMarkdown> :
                <div className={styles[openNews === news.id ? 'open' : 'description']} dangerouslySetInnerHTML={{__html: xss(news[(router.locale === 'ru' ? '' : 'eng_') + 'text'])}} />
              }
            </div>
            <button
              className="btn cloud"
              onClick={() => setOpenNews(openNews === news.id ? -1 : news.id)}
            >
              <p className={styles.find_out}>
                {t(openNews === news.id ? "news.hide" : "news.find_out")}
              </p>
            </button>
            {openNews !== news.id && (
              <div className={styles.transparent_block}></div>
            )}
          </div>
        </div>
      );
    })
  ) : (
    <></>
  );

  return (
    <Layout title= {t("newsTitle")} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66'/>
      <section className={styles.news}>
        <h2 className={styles.title}>{t("news.title")}</h2>
        {/* <div className={styles.main_img}>
          <Image src="/news.webp" alt="News" />
        </div> */}
        <div className={styles.articles}>
          {error ? (
            <h2 style={{ textAlign: "center", margin: "0 auto 5rem" }}>
              {t("wrong")}
            </h2>
          ) : count ? (
            articles
          ) : (
            <></>
          )}
        </div>
        {error || !count ? (
          <></>
        ) : (
          <div className={styles.paging}>
            <button
              className={styles.left}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prevState) => prevState - 1)}
            >
              {t("prev")}
            </button>
            {returnPaging(currentPage)}
            <button
              className={styles.right}
              disabled={currentPage === count}
              onClick={() => setCurrentPage((prevState) => prevState + 1)}
            >
              {t("next")}
            </button>
          </div>
        )}
      </section>
    </Layout>
  );
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ["common"])),
  },
});
